import {useCallback} from "react";
import {Loader} from "@mantine/core";
import classes from "./form-elements.module.css";

interface DocumentGeneratorInputProps {
    inputProps: {
        id: string;
        onChange: (e: any) => void;
        onKeyDown: (e: any) => void;
        value: string;
    };
    comment: string;
    companySearchEnabled: boolean;
    setDropdownOpen: (val: boolean) => void;
    suggestionList: string[];
    searching?: boolean;
    isDraft: boolean;
    onPromptNewFilling?: () => void;
}

export const DocumentGeneratorInput = ({
    inputProps,
    companySearchEnabled,
    setDropdownOpen,
    suggestionList,
    searching,
    isDraft,
    onPromptNewFilling,
}: DocumentGeneratorInputProps) => {
    const isDateInput = inputProps.id?.startsWith("Dato");

    const handleFocus = useCallback(
        (e: React.FocusEvent<HTMLInputElement>) => {
            if (isDraft && onPromptNewFilling) {
                e.target.blur();
                onPromptNewFilling();
                return;
            }
            if (companySearchEnabled) {
                setDropdownOpen(true);
            }
            if (isDateInput && suggestionList?.length > 0) {
                setDropdownOpen(true);
            }
        },
        [isDraft, onPromptNewFilling, companySearchEnabled, setDropdownOpen, isDateInput, suggestionList]
    );

    return (
        <>
            <input
                id={inputProps.id}
                value={inputProps.value}
                onChange={inputProps.onChange}
                onKeyDown={inputProps.onKeyDown}
                onFocus={handleFocus}
                className={classes.docgenInput}
            />
            {searching && <Loader size={16} />}
        </>
    );
};
